import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchAllCourses } from "../../../services/course";
import { toast } from "react-toastify";

export const fetchCourses = createAsyncThunk(
  "course/fetchContent",
  async () => {
    try {
      const { status, data } = await fetchAllCourses();
      if (status === 200) {
        return data?.data;
      } else if (status === 401) {
        toast.error(data?.message);
      } else {
        toast.error(data?.message);
      }
    } catch (error) {}
  }
);
export const updateCourse = createAsyncThunk(
  "course/updateCourse",
  async () => {
    try {
      const { status, data } = await fetchAllCourses();
      if (status === 200) {
        return data?.data;
      } else if (status === 401) {
        toast.error(data?.message);
      } else {
        toast.error(data?.message);
      }
    } catch (error) {}
  }
);
